import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "./context/GlobalContextProvider.jsx";
import useAuthorityConfiguration from "../api/utilities/useAuthorityConfiguration.js";
import {UserApi} from "../api/authority/generated/index";
import toast from "react-hot-toast";

/**
 * @returns {[UserSettings|null,updateUserSettings]}
 */
export default function useUserSettings() {

    let {context, setUserSettings} = useContext(GlobalContext);

    let authorityConfiguration = useAuthorityConfiguration();

    let [refresh, setRefresh] = useState(true);

    let updateUserSettings = (newUserSettings) => {
        new UserApi(authorityConfiguration)
            .updateUserSettings({
                userId: context.currentIdentity.user.id,
                userSettings: newUserSettings,
            })
            .then(setUserSettings)
            .catch(() => {
                toast.error('Unable to save user settings.');
            });
    };

    useEffect(() => {
        setRefresh(true);
    }, [context.currentIdentity, context.currentIdentity.user.id]);

    useEffect(() => {
        if (refresh) {
            setRefresh(false);
            return;
        }

        if (!context.currentIdentity.user.id) {
            return;
        }

        new UserApi(authorityConfiguration)
            .getUserSettings({
                userId: context.currentIdentity.user.id,
            })
            .then(setUserSettings)
            .catch(() => {
                toast.error('Unable to load user settings.');
            });

    }, [refresh]);

    return [context.currentUserSettings, updateUserSettings];
}
